module.exports = __webpack_public_path__ + "static/media/instabannermobil.d4a13321.png";